// src/pages/personal/analytics/FeedbackPage.tsx
import React from 'react';
import { AdaptiveLayout } from '@/components/ui/Layout';
import FeedbackSection from './FeedbackSection/FeedbackSection';

const FeedbackPage: React.FC = () => {
  return (
    <AdaptiveLayout>
      <FeedbackSection />
    </AdaptiveLayout>
  );
};

export default FeedbackPage;